import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AppProvider, useApp } from "@/lib/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Mostrador from "@/pages/Mostrador";
import POS from "@/pages/POS";
import Cash from "@/pages/Cash";
import Tickets from "@/pages/Tickets";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

import "@/App.css";

function RequireAuth({ children }) {
  const { user } = useApp();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function Shell() {
  return (
    <Layout>
      <Routes>
        <Route path="/pos"      element={<Mostrador />} />
        <Route path="/touch"    element={<POS />} />
        <Route path="/cash"     element={<Cash />} />
        <Route path="/tickets"  element={<Tickets />} />
        <Route path="/reports"  element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/pos" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <RequireAuth>
                <Shell />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
